import TextInput from "../../../../Comon/TextInput/TextInput";
import React from "react";

export default function PersonalizationTextarea({
                                                 title = 'Title',
                                                 placeholder,
                                                 value,
                                                 setValue,
                                                 disabled = false,
                                                 errorMessage = null,
                                                    labelHelpText
                                             }) {

    return <div>
        <TextInput
            hideErrorMessageIfNoMessage={true}
            rows={7}
            maxlength="450"
            label={title}
            mode={"white"}
            placeholder={placeholder ?? 'Type here...'}
            type={"textarea"}
            disabled={disabled}
            setValue={(val) => setValue(val)}
            value={value}
            labelHelpText={labelHelpText}
        />

        {
            errorMessage && (
                <div
                    style={{
                        color: 'red',
                        marginLeft: '33px',
                        fontSize: '12px',
                        marginTop: '5px',
                    }}
                >
                    {typeof errorMessage === 'string' ? (
                        <div>{errorMessage}</div>  // Render the errorMessage as a string
                    ) : (
                        errorMessage.map((item, index) => (
                            <div key={index}>{item}</div>  // Map over the array if it's an array
                        ))
                    )}
                </div>
            )
        }

    </div>

}
